import { db } from '../firebase';
import { collection, query, getDocs, addDoc, doc, deleteDoc, serverTimestamp, orderBy } from 'firebase/firestore';
import { PayrollAdjustment } from '../types';
import { getSettings } from './settingsService';
import { getFormattedTimestamp } from '../lib/utils';

export const addPayrollAdjustment = async (
  tenantId: string,
  adjustment: Omit<PayrollAdjustment, 'id' | 'timestamp' | 'tenantId'>
): Promise<string> => {
  const settings = await getSettings(tenantId);
  const timezone = settings?.timezone || 'UTC';
  const formattedTime = getFormattedTimestamp(timezone);

  const colRef = collection(db, 'tenants', tenantId, 'payroll_adjustments');
  const docRef = await addDoc(colRef, {
    ...adjustment,
    tenantId,
    timestamp: serverTimestamp(),
    formattedTimestamp: formattedTime,
  });
  return docRef.id;
};

export const getPayrollAdjustments = async (tenantId: string): Promise<PayrollAdjustment[]> => {
  const colRef = collection(db, 'tenants', tenantId, 'payroll_adjustments');
  const q = query(colRef, orderBy('timestamp', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  } as PayrollAdjustment));
};

export const deletePayrollAdjustment = async (tenantId: string, adjustmentId: string): Promise<void> => {
  const docRef = doc(db, 'tenants', tenantId, 'payroll_adjustments', adjustmentId);
  await deleteDoc(docRef);
};
